export default {
  "en": {
    "Home": "Home",
    "Users": "Users",
    "Investors": "Investors",
    "Properties": "Properties",
    "Opportunities": "Opportunities",
    "Tokens": "Tokens",
    "Settings": "Settings",
    "Countries": "Countries",
    "Nationalities": "Nationalities",
    "InvestorCategories": "Investor Categories",
    "PropertyTypes": "Property Types",
    "InvestorKycStatuses": "Investor KYC Statuses",
    "WalletStatuses": "Wallet Statuses",
    "PropertyListingStatuses": "Property Listing Statuses",
    "OpportunityStatuses": "Opportunity Statuses",
    "TokenStatuses": "Token Statuses",
    "PurchaseOrderStatuses": "Purchase Order Statuses",
    "WalletTransactionStatuses": "Wallet Transaction Statuses",

    "UsersManagement": "Users Management",
    "PropertyDetails": "Property Details",
    "PropertyImages": "Property Images",
    "PropertyDocuments": "Property Documents",
    "PropertyValuations": "Property Valuations",
    "PropertyRentalData": "Property Rental Data",
    "OpportunityDetails": "Opportunity Details",
    "OpportunityFees": "Opportunity Fees",
    "ChangePassword": "Change Password",
    "ForgotPassword": "Forgot Password",
    "ResetPassword": "Reset Password",
    "CheckCode": "Check Code",
    "NotAuthorized": "Not Authorized",
    "Profile": "Profile",
    "Register": "Register",
    "Login": "Login",

    "Email": "Email",
    "Password": "Password",
    "Signup": "Sign Up",
    "RememberMe": "Remember Me",
    "ForgetPassword": "Forget Password",
    "WelcomeBackPleaseLogin": "Welcome back, please login to your account",
    "LoginFailed": "Login Failed",
    "InvalidUsernameOrPassword": "Invalid username or password",

    "Add": "Add",
    "AddNew": "Add New",
    "Update": "Update",
    "Edit": "Edit",
    "Delete": "Delete",
    "View": "View",
    "Save": "Save",
    "Submit": "Submit",
    "Cancel": "Cancel",
    "Close": "Close",
    "Back": "Back",
    "Search": "Search",
    "Filter": "Filter",
    "Filters": "Filters",
    "Reset": "Reset",
    "Clear": "Clear",
    "Confirm": "Confirm",
    "Action": "Action",
    "Actions": "Actions",
    "NameAR": "Name AR",
    "NameEN": "Name EN",
    "Code": "Code",
    "Status": "Status",
    "Title": "Title",
    "Description": "Description",
    "Details": "Details",
    "Date": "Date",
    "StartDate": "Start Date",
    "EndDate": "End Date",
    "From": "From",
    "To": "To",
    "Image": "Image",
    "Images": "Images",
    "Document": "Document",
    "Documents": "Documents",
    "FileName": "File Name",
    "FilePath": "File Path",
    "Notes": "Notes",
    "Comment": "Comment",
    "Value": "Value",
    "Amount": "Amount",
    "Price": "Price",
    "Percentage": "Percentage",
    "IsActive": "Is Active",
    "CreatedDate": "Created Date",
    "UpdatedDate": "Updated Date",
    "Success": "Success",
    "Error": "Error",
    "Warning": "Warning",
    "Info": "Info",
    "Loading": "Loading",
    "NoDataFound": "No data found",
    "DeletedSuccessfully": "Deleted successfully",
    "SavedSuccessfully": "Saved successfully",
    "UpdatedSuccessfully": "Updated successfully",
    "DeleteConfirmText": "This item will be deleted",

    "Country": "Country",
    "Nationality": "Nationality",
    "InvestorCategory": "Investor Category",
    "PropertyType": "Property Type",
    "WalletStatus": "Wallet Status",
    "OpportunityStatus": "Opportunity Status",
    "TokenStatus": "Token Status",
    "PurchaseOrder": "Purchase Order",
    "PurchaseOrderStatus": "Purchase Order Status",
    "WalletTransactionStatus": "Wallet Transaction Status",
    "Property": "Property",
    "Opportunity": "Opportunity",
    "Fee": "Fee",
    "Fees": "Fees",
    "Valuation": "Valuation",
    "Valuations": "Valuations",
    "RentalData": "Rental Data",

    "generalOpportunityData": "General Opportunity Data",
    "opportunityCode": "Opportunity Code",
    "property": "Property",
    "status": "Status",
    "opportunityNameAr": "Opportunity Name (AR)",
    "opportunityNameEn": "Opportunity Name (EN)",
    "offeringValue": "Offering Value",
    "totalTokens": "Total Tokens",
    "tokenPrice": "Token Price",
    "currencyCode": "Currency Code",
    "minPurchaseTokens": "Min Purchase Tokens",
    "maxPurchaseTokens": "Max Purchase Tokens",
    "subscriptionStart": "Subscription Start",
    "subscriptionEnd": "Subscription End",
    "AddNewOpportunity": "Add New Opportunity",
    "SaveChanges": "Save Changes",
    "Back": "Back",
    "QuickSearch": "Quick Search",
    "NameOrCode": "Name or Code",
    "SearchPlaceholder": "Start typing opportunity name or code (min 3 chars)...",
    "TypeMoreToSearch": "Type more characters to search...",
    "OrAdvancedFilters": "Or Advanced Filters",
    "TokenPriceFrom": "Token Price (From)",
    "TokenPriceTo": "Token Price (To)",
    "ExpectedReturnFrom": "Expected Return (From)",
    "ExpectedReturnTo": "Expected Return (To)",
    "ApplyFilters": "Apply Filters",
    "ResetSearch": "Reset Search",
    "OpportunityFees": "Opportunity Fees",
    "OpportunityDocuments": "Opportunity Documents",
    "MainInfo": "Main Info",
    "Add New Fee": "Add New Fee",
    "Edit Fee": "Edit Fee",
    "Save": "Save",
    "Cancel": "Cancel",
    "Code": "Code",
    "Fees Name Arabic": "Fees Name (Arabic)",
    "Fees Name English": "Fees Name (English)",
    "Fees Type": "Fees Type",
    "Calculation Method": "Calculation Method",
    "OpportunityFeesDetails": "Opportunity Fees Details",
    "Add Fee": "Add Fee",
    "Type": "Type",
    "Method": "Method",
    "Confirm Delete": "Confirm Delete",
    "Are you sure?": "Are you sure you want to delete this fee?",
    "Buyer": "Buyer",
    "Platform": "Platform",
    "Seller": "Seller",
    "Percentage": "Percentage",
    "Fixed": "Fixed",
    "Add New Document": "Add New Document",
    "Edit Document": "Edit Document",
    "Document Type": "Document Type",
    "File Name": "File Name",
    "File Path": "File Path",
    "File Extension": "File Extension",
    "Opportunity Documents Details": "Opportunity Documents Details",
    "Add Document": "Add Document",
    "File": "File",
    "Offering Memo": "Offering Memo",
    "Terms & Conditions": "Terms & Conditions",
    "Property Report": "Property Report",
    "Active": "Active",
    "Inactive": "Inactive",
    "Search": "Search",
    "TokenSerial": "Token Serial",
    "Opportunity": "Opportunity",
    "SelectOpportunity": "Select Opportunity",
    "Property": "Property",
    "SelectProperty": "Select Property",
    "Status": "Status",
    "SelectStatus": "Select Status",
    "TotalTokens": "Total Tokens",
    "Serial": "Serial",
    "Seq": "Seq",
    "Investor": "Investor",
    "PurchaseOrder": "Purchase Order",
    "Actions": "Actions",
    "DeletedSuccessfully": "Deleted Successfully",
    "ViewDetails": "View Details",
    "Tokens": "Tokens",
    "PurchaseOrders": "Purchase Orders",
    "Owner": "Owner",
    "CodeOrName": "Code or Name",
    "SelectPropertyType": "Select Property Type",
    "SelectCity": "Select City",
    "ListingStatus": "Listing Status",
    "AddNewProperty": "Add New Property",
    "BasicInformation": "Basic Information",
  "propertyCode": "Property Code",
  "propertyNameAr": "Property Name (Arabic)",
  "propertyNameEn": "Property Name (English)",
  "propertyType": "Property Type",
  "PropertyListingStatus": "Listing Status",

  "LocationDetails": "Location Details",
  "country": "Country",
  "region": "Region",
  "city": "City",
  "district": "District",

  "AdditionalDetails": "Additional Details",
  "titleDeedNo": "Title Deed Number",
  "estimatedPropertyValue": "Estimated Value",
  "shortDescription": "Short Description",
  "UploadNewImages": "Upload New Images",
  "DragDropImages": "Drag & Drop images here",
  "OrClickToBrowse": "Or click to browse",
  "PropertyGallery": "Property Gallery",
  "Images": "Images",
  "SaveChanges": "Save Changes",
  "Primary": "Primary",
  "SetAsPrimary": "Set as Primary",
  "ImageTitleAr": "Image Title (Arabic)",
  "ImageTitleEn": "Image Title (English)",
  "Order": "Order",
  "Active": "Active",
  "Inactive": "Inactive",
  "Delete": "Delete",
  "NoImagesUploadedYet": "No images uploaded yet",
  "UseSectionAboveToUpload": "Use the section above to upload your first images",
  "ConfirmDelete": "Confirm Delete",
  "AreYouSureDeleteImage": "Are you sure you want to delete this image?",
  "Success": "Success",
  "ImagesSavedSuccessfully": "Images saved successfully",
  "ImageDeletedSuccessfully": "Image deleted successfully",
  "PropertyDocumentsDetails": "Property Documents Details",
  "PleaseSavePropertyFirst": "Please save the property first to manage documents",
  "RentalData": "Rental Data",
  "RentalAmount": "Rental Amount",
  "Frequency": "Frequency",
  "ContractStart": "Contract Start",
  "ContractEnd": "Contract End",
  "OccupancyRate": "Occupancy Rate",
  "AnnualYield": "Annual Yield",
  "Notes": "Notes",
  "SaveChanges": "Save Changes",
  "RentalDataSavedSuccessfully": "Rental data saved successfully",
  "Success": "Success",
  "Error": "Error",
  "AddOrEditProperties": "Add Or Edit Properties",
  "AddOrEditOpportunities": "Add Or Edit Opportunities",
  "AddNew": "Add New",
  "Name": "Name",
  "Email": "Email",
  "PhoneNumber": "Phone Number",
  "Role": "Role",
  "Status": "Status",
  "Confirm": "Confirm",
  "ResetPassword": "Reset Password",
  "Update": "Update",
  "Cancel": "Cancel",
  "Submit": "Submit",
  "Country": "Country",
  "Password": "Password",
  "Success": "Success",
  "Role *": "Role *",
  "Full Name *": "Full Name *",
  "Email *": "Email *",
  "Phone Number *": "Phone Number *",
  "Areyousureyouwantdeletethisrecord": "Are you sure you want to delete this record",
  "Passwordchangedsuccessfully": "Password changed successfully",
  "Characters": "Characters",
  "ContainsNumber": "Must contain at least one number",
  "ContainsUppercase": "Must contain one uppercase letter",
  "ContainsSpecialCharacter": "Must contain one special character",
   "InvestorDetails": "Investor Details",
    "BasicInformation": "Basic Information",
    "InvestorCode": "Investor Code",
    "FullName": "Full Name",
    "DateOfBirth": "Date of Birth",

    "IdentityDetails": "Identity Details",
    "Nationality": "Nationality",
    "NationalID_Iqama": "National ID / Iqama",
    "ID_Type": "ID Type",
    "NationalID": "National ID",
    "Iqama": "Iqama",
    "Passport": "Passport",

    "InvestmentStatus": "Investment Status",
    "InvestorCategory": "Investor Category",
    "KYCStatus": "KYC Status",
    "EligibilityToInvest": "Eligibility to Invest",
    "Category": "Category",
    "CanInvest": "Can Invest",
    "LatestInvestors": "Latest Investors",
    "LatestOpportunities": "Latest Opportunities",
    "OpenOpportunities": "Open Opportunities",
    "Keymetricsandrecentactivityacrosstheplatform": "Key metrics and recent activity across the platform",
    "DashboardOverview": "Dashboard Overview",
    "Active": "Active",
    "Updated": "Updated",
    "Live": "Live",
    "Today": "Today",
    "Pending": "Pending",
    "Open": "Open",
    "Closed": "Closed",
    "ComplaintSuggestions": "Complaint Suggestions",
    "TotalInvestors": "Total Investors",
    "Total": "Total",
    "ComplaintCode": "Complaint Code",
    "InvestorCode": "Investor Code",
    "Completed": "Completed",
    "ComplaintDetails": "Complaint Details",
    "Attachment": "Attachment",
    "Content": "Content",
    "RecordsReports": "Records & Reports",
    "InvestorOpportunities": "Investor Opportunities",
    "InvestorReport": "Investor Report",
    "InvestorOpportunitiesReport": "Investor Opportunities Report",
    "SelectInvestor": "Select Investor",
    "ViewReport": "View Report",
    "IsCommissionExempt": "Is Commission Exempt",
    "commissionPercentage": "Commission Percentage",
    "PropertyOwners": "Property Owners",
    "OwnerDetails": "Owner Details",
    "OwnerCode": "Owner Code",
    "RelatedData": "Related Data",
    "AddOrEditPropertyOwner": "Add or Edit Property Owner",
    "TotalEntitlements": "Total Entitlements",
"TotalPaid": "Total Paid",
"CurrentBalance": "Current Balance",
"FinancialTransactionsList": "Financial Transactions List",
"TransactionDate": "Transaction Date",
"Type": "Type",
"Amount": "Amount",
"ReferenceNumber": "Ref Number",
"OpportunityNo": "Opportunity ID",
"Notes": "Notes",
"Entitlement": "Entitlement",
"Payment": "Payment",
"OpportunitiesCount": "Opportunities Count",
"Print": "Print",
"Active": "Active",
"Inactive": "Inactive",
"FullNameAr": "Arabic Full Name",
"FullNameEn": "English Full Name",
"ContactAndAccountInfo": "Contact & Accounting Info",
"PhoneNumber": "Phone Number",
"Email": "Email",
"ErpAccountId": "ERP Account ID",
"IdentityAndStatus": "Identity & Status",
"Status": "Status",
"Active": "Active",
"Inactive": "Inactive"
  },

  "ar": {
    "FullNameAr": "الاسم بالعربي",
"FullNameEn": "الاسم بالإنجليزي",
"ContactAndAccountInfo": "بيانات التواصل والحساب المحاسبي",
"PhoneNumber": "رقم الهاتف",
"Email": "البريد الإلكتروني",
"ErpAccountId": "رقم حساب ERP",
"IdentityAndStatus": "الهوية وحالة الحساب",
"Status": "الحالة",
"Active": "نشط",
"Inactive": "غير نشط",
    "OpportunitiesCount": "عدد الفرص المرتبطة",
"Print": "طباعة",
"Active": "نشط",
"Inactive": "غير نشط",
    "TotalEntitlements": "إجمالي الاستحقاقات",
"TotalPaid": "إجمالي السداد",
"CurrentBalance": "الرصيد المتبقي",
"FinancialTransactionsList": "كشف الحركات المالية",
"TransactionDate": "تاريخ الحركة",
"Type": "نوع الحركة",
"Amount": "المبلغ",
"ReferenceNumber": "رقم المرجع",
"OpportunityNo": "رقم الفرصة",
"Notes": "الملاحظات",
"Entitlement": "استحقاق له",
"Payment": "سداد إليه",
    "PropertyOwners": "الملاك",
    "OwnerDetails": "بيانات المالك",
    "OwnerCode": "كود المالك",
    "RelatedData": "البيانات المرتبطة",
    "AddOrEditPropertyOwner": "إضافة أو تعديل مالك",
    "commissionPercentage": "نسبة العمولة",
    "IsCommissionExempt": "معفى من العمولة",
    "ViewReport": "عرض التقرير",
    "SelectInvestor": "اختر المستثمر",
    "InvestorOpportunities": "فرص المستثمرين",
    "InvestorReport": "تقرير المستثمرين",
    "InvestorOpportunitiesReport": "تقرير فرص المستثمرين",
    "RecordsReports": "التقارير والسجلات",
    "Content": "المحتوى",
    "Attachment": "مرفق",
    "ComplaintDetails": "تفاصيل الشكوى",
    "Completed": "مكتملة",
    "ComplaintCode": "كود الشكوى",
    "InvestorCode": "كود المستثمر",
    "TotalInvestors": "إجمالي المستثمرين",
    "Total": "إجمالي",
    "ComplaintSuggestions": "الشكاوى والاقتراحات",
    "Active": "نشط",
    "Updated": "تم التحديث",
    "Live": "مباشر",
    "Today": "اليوم",
    "Pending": "قيد الانتظار",
    "Open": "فتح",
    "Closed": "مغلق",
    "DashboardOverview": "نظرة عامة على لوحة التحكم",
    "Keymetricsandrecentactivityacrosstheplatform": "المقاييس الرئيسية والنشاط الأخير عبر المنصة",
    "OpenOpportunities": "فرص مفتوحة",
    "LatestInvestors": "أحدث المستثمرين",
    "LatestOpportunities": "أحدث الفرص",
    "CanInvest": "مؤهل للاستثمار",
    "Category": "الفئة",
    "InvestorDetails": "بيانات المستثمر",
    "BasicInformation": "البيانات الأساسية",
    "InvestorCode": "كود المستثمر",
    "FullName": "الاسم بالكامل",
    "DateOfBirth": "تاريخ الميلاد",

    "IdentityDetails": "بيانات الهوية",
    "Nationality": "الجنسية",
    "NationalID_Iqama": "الرقم القومي / الإقامة",
    "ID_Type": "نوع الهوية",
    "NationalID": "رقم قومي",
    "Iqama": "إقامة",
    "Passport": "جواز سفر",

    "InvestmentStatus": "حالة الاستثمار",
    "InvestorCategory": "تصنيف المستثمر",
    "KYCStatus": "حالة التحقق (KYC)",
    "EligibilityToInvest": "مؤهل للاستثمار",
    "AddNew": "إضافة جديد",
  "Email": "البريد الإلكتروني",
  "PhoneNumber": "رقم الهاتف",
  "Role": "الصلاحية",
  "Status": "الحالة",
  "Action": "إجراء",
  "Confirm": "تأكيد",
  "ResetPassword": "إعادة تعيين كلمة المرور",
  "Update": "تحديث",
  "Cancel": "إلغاء",
  "Submit": "حفظ",
  "Country": "الدولة",
  "Password": "كلمة المرور",
  "Success": "تم بنجاح",
  "Role *": "الصلاحية *",
  "Full Name *": "الاسم بالكامل *",
  "Email *": "البريد الإلكتروني *",
  "Phone Number *": "رقم الهاتف *",
  "Areyousureyouwantdeletethisrecord": "هل أنت متأكد من حذف هذا السجل؟",
  "Passwordchangedsuccessfully": "تم تغيير كلمة المرور بنجاح",
  "Characters": "حروف",
  "ContainsNumber": "يجب أن يحتوي على رقم واحد على الأقل",
  "ContainsUppercase": "يجب أن يحتوي على حرف كبير واحد",
  "ContainsSpecialCharacter": "يجب أن يحتوي على رمز خاص واحد",
    "AddOrEditOpportunities": "إضافة أو تعديل الفرص",
    "AddOrEditProperties": "إضافة أو تعديل العقارات",
    "RentalData": "بيانات الإيجار",
  "RentalAmount": "قيمة الإيجار",
  "Frequency": "دورية الدفع",
  "ContractStart": "بداية العقد",
  "ContractEnd": "نهاية العقد",
  "OccupancyRate": "نسبة الإشغال",
  "AnnualYield": "العائد السنوي",
  "Notes": "ملاحظات",
  "SaveChanges": "حفظ التغييرات",
  "RentalDataSavedSuccessfully": "تم حفظ بيانات الإيجار بنجاح",
  "Success": "تم بنجاح",
  "Error": "خطأ",
    "PleaseSavePropertyFirst": "يرجى حفظ العقار أولاً لإدارة المستندات",
  "PropertyDocumentsDetails": "تفاصيل مستندات العقار",
  "UploadNewImages": "رفع صور جديدة",
  "DragDropImages": "اسحب وأفلت الصور هنا",
  "OrClickToBrowse": "أو اضغط للتصفح",
  "PropertyGallery": "معرض صور العقار",
  "Images": "صور",
  "SaveChanges": "حفظ التغييرات",
  "Primary": "أساسية",
  "SetAsPrimary": "تعيين كأساسية",
  "ImageTitleAr": "عنوان الصورة (عربي)",
  "ImageTitleEn": "عنوان الصورة (إنجليزي)",
  "Order": "الترتيب",
  "Active": "نشط",
  "Inactive": "غير نشط",
  "Delete": "حذف",
  "NoImagesUploadedYet": "لم يتم رفع أي صور بعد",
  "UseSectionAboveToUpload": "استخدم القسم أعلاه لرفع صورك الأولى",
  "AreYouSureDeleteImage": "هل أنت متأكد من حذف هذه الصورة؟",
  "Success": "تم بنجاح",
  "ImagesSavedSuccessfully": "تم حفظ الصور بنجاح",
  "ImageDeletedSuccessfully": "تم حذف الصورة بنجاح",
    "BasicInformation": "المعلومات الأساسية",
  "propertyCode": "كود العقار",
  "propertyNameAr": "اسم العقار (بالعربي)",
  "propertyNameEn": "اسم العقار (بالإنجليزي)",
  "propertyType": "نوع العقار",
  "PropertyListingStatus": "حالة عرض العقار",

  "LocationDetails": "تفاصيل الموقع",
  "country": "الدولة",
  "region": "المنطقة",
  "city": "المدينة",
  "district": "الحي",

  "AdditionalDetails": "تفاصيل إضافية",
  "titleDeedNo": "رقم صك الملكية",
  "estimatedPropertyValue": "القيمة التقديرية للعقار",
  "shortDescription": "وصف مختصر",
    "AddNewProperty": "إضافة عقار جديد",
    "ListingStatus": "حالة الطرح",
    "SelectCity": "اختر المدينة",
    "SelectPropertyType": "اختر نوع العقار",
    "CodeOrName": "الكود أو الاسم",
  "Owner": "المالك",
    "Home": "الرئيسية",
    "Users": "المستخدمون",
    "Investors": "المستثمرون",
    "Properties": "العقارات",
    "Opportunities": "الفرص",
    "Tokens": "التوكنات",
    "PurchaseOrders": "أوامر الشراء",
    "Settings": "الإعدادات",
    "Countries": "الدول",
    "Nationalities": "الجنسيات",
    "InvestorCategories": "فئات المستثمرين",
    "PropertyTypes": "أنواع العقارات",
    "InvestorKycStatuses": "حالات اعرف عميلك للمستثمر",
    "WalletStatuses": "حالات المحافظ",
    "PropertyListingStatuses": "حالات طرح العقار",
    "OpportunityStatuses": "حالات الفرص",
    "TokenStatuses": "حالات التوكنات",
    "PurchaseOrderStatuses": "حالات أوامر الشراء",
    "WalletTransactionStatuses": "حالات معاملات المحفظة",

    "UsersManagement": "إدارة المستخدمين",
    "PropertyDetails": "تفاصيل العقار",
    "PropertyImages": "صور العقار",
    "PropertyDocuments": "مستندات العقار",
    "PropertyValuations": "تقييمات العقار",
    "PropertyRentalData": "بيانات الإيجار",
    "OpportunityDetails": "تفاصيل الفرصة",
    "OpportunityDocuments": "مستندات الفرصة",
    "OpportunityFees": "رسوم الفرصة",
    "ChangePassword": "تغيير كلمة المرور",
    "ForgotPassword": "نسيت كلمة المرور",
    "ResetPassword": "إعادة تعيين كلمة المرور",
    "CheckCode": "التحقق من الرمز",
    "NotAuthorized": "غير مصرح لك",
    "Profile": "الملف الشخصي",
    "Register": "تسجيل",
    "Login": "تسجيل الدخول",

    "Email": "البريد الإلكتروني",
    "Password": "كلمة المرور",
    "Signup": "إنشاء حساب",
    "RememberMe": "تذكرني",
    "ForgetPassword": "نسيت كلمة المرور",
    "WelcomeBackPleaseLogin": "مرحبًا بعودتك، يرجى تسجيل الدخول إلى حسابك",
    "LoginFailed": "فشل تسجيل الدخول",
    "InvalidUsernameOrPassword": "اسم المستخدم أو كلمة المرور غير صحيحة",

    "Add": "إضافة",
    "AddNew": "إضافة جديد",
    "Update": "تحديث",
    "Edit": "تعديل",
    "Delete": "حذف",
    "View": "عرض",
    "Save": "حفظ",
    "Submit": "إرسال",
    "Cancel": "إلغاء",
    "Close": "إغلاق",
    "Back": "رجوع",
    "Search": "بحث",
    "Filter": "تصفية",
    "Filters": "الفلاتر",
    "Reset": "إعادة تعيين",
    "Clear": "مسح",
    "Confirm": "تأكيد",
    "Actions": "الإجراءات",
    "NameAR": "الاسم بالعربى",
    "NameEN": "الاسم بالانجليزى",
    "Code": "الكود",
    "Status": "الحالة",
    "Type": "النوع",
    "Title": "العنوان",
    "Description": "الوصف",
    "Details": "التفاصيل",
    "Date": "التاريخ",
    "StartDate": "تاريخ البداية",
    "EndDate": "تاريخ النهاية",
    "From": "من",
    "To": "إلى",
    "Image": "صورة",
    "Images": "صور",
    "Document": "مستند",
    "Documents": "مستندات",
    "FileName": "اسم الملف",
    "FilePath": "مسار الملف",
    "Notes": "ملاحظات",
    "Comment": "تعليق",
    "Value": "القيمة",
    "Amount": "المبلغ",
    "Price": "السعر",
    "Percentage": "النسبة",
    "IsActive": "نشط",
    "CreatedDate": "تاريخ الإنشاء",
    "UpdatedDate": "تاريخ التحديث",
    "Success": "نجاح",
    "Error": "خطأ",
    "Warning": "تنبيه",
    "Info": "معلومة",
    "Loading": "جارٍ التحميل",
    "NoDataFound": "لا توجد بيانات",
    "DeletedSuccessfully": "تم الحذف بنجاح",
    "SavedSuccessfully": "تم الحفظ بنجاح",
    "UpdatedSuccessfully": "تم التحديث بنجاح",
    "DeleteConfirmText": "سيتم حذف هذا العنصر",

    "Country": "الدولة",
    "Nationality": "الجنسية",
    "InvestorCategory": "فئة المستثمر",
    "PropertyType": "نوع العقار",
    "WalletStatus": "حالة المحفظة",
    "OpportunityStatus": "حالة الفرصة",
    "TokenStatus": "حالة التوكن",
    "PurchaseOrder": "أمر الشراء",
    "PurchaseOrderStatus": "حالة أمر الشراء",
    "WalletTransactionStatus": "حالة معاملة المحفظة",
    "Property": "العقار",
    "Opportunity": "الفرصة",
    "Fee": "رسوم",
    "Fees": "الرسوم",
    "Valuation": "تقييم",
    "Valuations": "تقييمات",
    "RentalData": "بيانات الإيجار",

    "PurchaseOrders": "طلبات الشراء",
    "OrderNumber": "رقم الطلب",
    "SearchByOrderNum": "بحث برقم الطلب",
    "Tokens": "الرموز",
    "NetAmount": "الصافي",
    "Wallet": "المحفظة",
    "TotalOrders": "إجمالي الطلبات",
    "AddOrder": "إضافة طلب",
    "Tokens": "الرموز",
    "Search": "بحث",
    "TokenSerial": "الرقم التسلسلي للتوكن",
    "Opportunity": "الفرصة الاستثمارية",
    "SelectOpportunity": "اختر الفرصة",
    "Property": "العقار",
    "SelectProperty": "اختر العقار",
    "Status": "الحالة",
    "SelectStatus": "اختر الحالة",
    "ResetSearch": "إعادة ضبط البحث",
    "ApplyFilters": "تطبيق الفلاتر",
    "TotalTokens": "إجمالي التوكنز",
    "Serial": "السيريال",
    "Seq": "التسلسل",
    "Investor": "المستثمر",
    "PurchaseOrder": "أمر الشراء",
    "Actions": "العمليات",
    "DeletedSuccessfully": "تم الحذف بنجاح",
    "ConfirmDelete": "تأكيد الحذف",
    "ViewDetails": "عرض التفاصيل",
    "Add New Document": "إضافة مستند جديد",
    "Edit Document": "تعديل المستند",
    "Document Type": "نوع المستند",
    "File Name": "اسم الملف",
    "File Path": "مسار الملف",
    "File Extension": "امتداد الملف",
    "Opportunity Documents Details": "تفاصيل مستندات الفرصة",
    "Add Document": "إضافة مستند",
    "File": "الملف",
    "Offering Memo": "مذكرة العرض",
    "Terms & Conditions": "الشروط والأحكام",
    "Property Report": "تقرير العقار",
    "Active": "نشط",
    "Inactive": "غير نشط",
    "Buyer": "مشتري",
    "Platform": "المنصة",
    "Seller": "بائع",
    "Percentage": "نسبة مئوية",
    "Fixed": "مبلغ ثابت",
    "Add New Fee": "إضافة رسوم جديدة",
    "Edit Fee": "تعديل الرسوم",
    "Save": "حفظ",
    "Cancel": "إلغاء",
    "Fees Name Arabic": "اسم الرسوم (بالعربي)",
    "Fees Name English": "اسم الرسوم (بالإنجليزي)",
    "Fees Type": "نوع الرسوم",
    "Calculation Method": "طريقة الحساب",
    "Value": "القيمة",
    "Notes": "ملاحظات",
    "Opportunity Fees Details": "تفاصيل رسوم الفرصة",
    "AddFee": "إضافة رسوم",
    "Method": "الطريقة",
    "Are you sure?": "هل أنت متأكد من مسح هذه الرسوم؟",
    "MainInfo": "البيانات الرئيسية",
    "QuickSearch": "البحث السريع",
    "NameOrCode": "الاسم أو الكود",
    "SearchPlaceholder": "ابدأ بكتابة اسم الفرصة أو الكود (3 حروف على الأقل)...",
    "TypeMoreToSearch": "اكتب حرفاً آخر للبحث...",
    "OrAdvancedFilters": "أو فلاتر متقدمة",
    "TokenPriceFrom": "سعر التوكن (من)",
    "TokenPriceTo": "سعر التوكن (إلى)",
    "ExpectedReturnFrom": "العائد المتوقع (من)",
    "ExpectedReturnTo": "العائد المتوقع (إلى)",
    "AddNewOpportunity": "اضافة فرصة جديدة",
    "generalOpportunityData": "البيانات العامة للفرصة",
    "opportunityCode": "كود الفرصة",
    "property": "المشروع",
    "status": "الحالة",
    "opportunityNameAr": "اسم الفرصة (عربي)",
    "opportunityNameEn": "اسم الفرصة (إنجليزي)",
    "offeringValue": "قيمة الطرح",
    "totalTokens": "إجمالي التوكنز",
    "tokenPrice": "سعر التوكن",
    "currencyCode": "العملة",
    "minPurchaseTokens": "الحد الأدنى للشراء",
    "maxPurchaseTokens": "الحد الأقصى للشراء",
    "subscriptionStart": "تاريخ بداية الاكتتاب",
    "subscriptionEnd": "تاريخ نهاية الاكتتاب",
  }
}
